import Vue from 'vue'
import qs from 'qs';
import axios from 'axios'

Vue.prototype.$http = axios;
axios.defaults.timeout = 60000;
axios.defaults.baseURL = '/api/'


//请求拦截器
axios.interceptors.request.use(
    config => {
        //  判断是否存在token，如果存在的话，则每个http header都加上token
        let token = localStorage.getItem('token-qzb')
        config.headers.token = token ? token : '';
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

//响应拦截器
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        // console.log(error)
        if (error.response) {
            return Promise.resolve(error)
        } else {
            return Promise.reject(error.response.data)
            //return Promise.resolve(error);//请求错误时，不会直接结束，将会继续传到then里面,无论请求成功还是失败，在成功的回调中都能收到通知
        }
    });

/**
 * *  POST请求
 * *  @param {String} url [请求的url]
 * *  @param {Object} params [请求时携带的参数]
 */
export function post(url, params, showToast) {
    return new Promise((resolve, reject) => {
        axios.post(url, params).then(res => {
            if (res.status === 200) {
                // // console.log(res);
                if (res.data.code !== 1) {
                    if (res.data.code == 0) {
                        this.$message.error(res.data.msg)
                    }
                }
                resolve(res.data)
            }
        }).catch(err => {
            // console.log(err);
        })
    })
}